<template>
  <div class="scenes">
    <template v-if="project">
      <el-card
        class="box-card"
        :class="{ 'active': activeScene == sceneIndex }"
        v-for="(item, sceneIndex) in items"
        :key="sceneIndex"
        v-show="showItem(item)"
      >
        <div v-if="showItem(item)" slot="header" class="scene" @click="changeVersion(sceneIndex)">
          <div class="name">
            {{ item.name }}
          </div>
          <div v-if="!loggedIn && !isPreview" class="buttons">
            <el-tooltip v-if="allowEdit" class="item" effect="dark" content="Zmień nazwę" placement="bottom" style="margin-left: 10px">
              <el-link @click="changeName(sceneIndex)" size="mini" icon="el-icon-edit" circle></el-link>
            </el-tooltip>
            <el-tooltip v-if="allowEdit" class="item" effect="dark" content="Utwórz kolejną wersję projektu" placement="bottom">
              <el-link @click="addNewVersion(sceneIndex)" size="mini" type="primary" icon="el-icon-document-copy" circle></el-link>
            </el-tooltip>
            <el-tooltip v-if="allowEdit" class="item" effect="dark" content="Usuń projekt" placement="bottom">
              <el-link @click="confirmRemoveVersion(sceneIndex)" size="mini" type="danger" icon="el-icon-delete" circle></el-link>
            </el-tooltip>
          </div>
        </div>
        <el-tabs v-if="activeScene == sceneIndex" v-model="activeName">
          <el-tab-pane v-if="showGuestList" label="Lista gości" name="guests">
            <Guests :sceneIndex="sceneIndex" />
          </el-tab-pane>
          <el-tab-pane label="Uwagi" name="note">
            <Note :sceneIndex="sceneIndex" />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>

    <el-row v-if="optionalItems.length" type="flex" justify="center">
      <el-button type="text" @click="toggleOptionalItems">
        <i :class="{ 'el-icon-arrow-down': showOptionalItems, 'el-icon-arrow-up': !showOptionalItems }"></i>
        {{ showOptionalItems ? 'Ukryj' : 'Pokaż' }} opcjonalne elementy ({{ optionalItems.length }})
      </el-button>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { resetZoom, restoreZoom } from '../../canvas';
import Guests from './Guests.vue';
import Note from './Note.vue';
import Editor from '../../classes/Editor'

export default {
  data() {
    return {
      activeName: 'guests',
      isMobile: false,
      removeDialogVisible: false,
      sceneDialogVisible: false,
      showOptionalItems: false,
      sceneToConfig: {}
    };
  },
  computed: {
    ...mapGetters('creator', ['scene', 'version', 'project', 'activeScene', 'activeVersion', 'isPreview', 'isBlocked', 'previewGuestIndex']),
    ...mapGetters('user', ['loggedIn']),
    allowEdit() {
      if (this.loggedIn) {
        return true;
      }

      return !this.isBlocked;
    },
    showGuestList() {
      return this.scene.attributes && this.scene.attributes.guestList === '1'
    },
    optionalItems() {
      return this.project.scenes.filter((item) => item.attributes.optional === '1')
    },
    items() {
      return this.project.scenes
    },
    // defaultItems() {
    //   const items = [...this.project.scenes].filter((item) => this.showOptionalItems ? true : !parseInt(item.attributes.optional || 0))
    //   return items.sort((a, b) => parseInt(a.attributes.optional || 0) - parseInt(b.attributes.optional || 0))
    // }
  },
  watch: {
    scene() {
      this.activeName = this.showGuestList ? 'guests' : 'note'
    }
  },
  mounted() {

    this.isMobile = window.innerWidth > 767 ? false : true;

    console.log('scene mounted function')

    Editor.addCallback('mouse:dblclick', (e) => {
      console.log('dbclick e', e)
      if (e.target && e.target.id === 'personalizedField' && !this.isPreview) {

        const isGuest = this.scene.guests && this.scene.guests.length
        const guest = isGuest ? this.scene.guests[0] : null

        if (isGuest) {
          this.setPreviewGuestIndex(isGuest ? 0 : null);
        } else {
          // Activate preview
          this.setPreview(true)
        }

        Editor.setPreview(guest, !isGuest)
        document.querySelector('#guestField').focus()
      }
    })

    Editor.addCallback('text:changed', (e) => {
      if (e.target && e.target.id === 'personalizedField' && this.previewGuestIndex !== null) {
        console.log('override guest text')
        this.setPreviewGuest({ content: e.target.text, display: e.target.text })
      }
    })

    Editor.addCallback('object:moving', (e) => {
      if (e.target && e.target.id === 'personalizedField') {
        console.log('override guest position')

        const personalizedCords = Editor.project.getPersonalizedCords()
        this.setGuestPosition({ x: e.target.left - personalizedCords.x, y: e.target.top - personalizedCords.y })
      }
    })
  },
  methods: {
    ...mapActions('creator', ['newSceneVersion', 'removeScene', 'setSceneName', 'setActiveSceneVersion', 'setPreviewGuest', 'setPreviewGuestIndex', 'setGuestPosition', 'setPreview']),
    showItem(item) {
      return this.showOptionalItems ? true : !parseInt(item.attributes.optional || 0)
    },
    changeName(sceneIndex) {
      this.$prompt('Wpisz nową nazwę dla tego projektu np. Zaproszenie wykropkowane', 'Zmień nazwę', {
        confirmButtonText: 'Zmień',
        cancelButtonText: 'Anuluj',
        inputValue: this.scene.name,
      }).then(({ value }) => {
        this.setSceneName({
          scene: sceneIndex,
          name: value,
        });
        this.$notify({
          title: 'OK!',
          dangerouslyUseHTMLString: true,
          message: `Nazwa zmieniona na: <b>${value}</b>`,
          type: 'success',
          position: 'bottom-right',
        });
      });
    },
    addNewVersion(scene) {
      resetZoom();
      this.newSceneVersion(scene);
      this.$nextTick(() => restoreZoom());
    },
    confirmRemoveVersion(index) {
      this.$confirm('Czy na pewno usunąć ten projekt?', 'Uwaga!', {
        type: 'warning',
        confirmButtonText: 'Tak',
      }).then(() => {
        console.log('remove scene ', index);
        this.removeScene(index);
      });
    },
    openSceneConfig(scene) {
      this.sceneDialogVisible = true;
      this.sceneToConfig = scene
    },
    handleClose() {
      this.sceneDialogVisible = false
    },
    async changeVersion(scene) {

      // We have to clear selection before scene change because after clear selection we have 
      // called callbacks and after that content of canvas is stored for wrong scene
      Editor.canvas.discardActiveObject()

      // Clear preview if enabled
      this.setPreviewGuestIndex(null)
      // Editor.setPreview(null)
      
      // Update state in vue
      this.setActiveSceneVersion({ scene, version: 0 })

      // Set current scene and version for proper canvas size calculation
      Editor.project.setScene(scene)
      Editor.project.setVersion(0)

      await this.$nextTick()
      console.log(this.version)
      console.log(this.version.content)
      // Get content from store and load in canvas
      await Editor.loadContent(this.version.content)
    },
    toggleOptionalItems() {
      this.showOptionalItems = !this.showOptionalItems
    }
  },
  components: {
    Note,
    Guests,
  },
};
</script>

<style lang="less" scoped>
.el-icon-delete {
  cursor: pointer;
  margin: 0;
}
.el-link.el-link--primary {
  margin: 0;
}
.box-card + .box-card {
  margin-top: 20px;
}
.el-link + .el-link {
  margin-left: 10px;
}
.scenes {
  padding-bottom: 70px;
  .scene {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .buttons {
      margin-left: auto;
    }
    .el-input-number {
      margin: 0;
    }
    .name {
      max-width: 200px;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 20px;
      overflow: hidden;
    }
  }
  .el-card {
    border: 2px solid transparent;
    transition: border 0.3s;
    &.active {
      border-color: #67c23a;

      .el-card__body {
        padding-top: 10px;
      }
    }
  }
}
.text {
  cursor: pointer;
  padding: 3px 0;
  .active {
    color: green;
  }
}
.el-card__header {
  border-bottom: 0;
  padding-bottom: 0;
}
.el-card__body {
  padding-top: 0;
  .el-button {
    font-weight: 400;
    i {
      margin-right: 5px;
    }
  }
}
.el-form {
  .el-form-item {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
